import { defineMessages } from 'react-intl';

export default defineMessages({
  suggestionResults: {
    id: 'global_wm_results',
    defaultMessage: 'results',
  },
});



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionItem/messages.js